import {Place} from "@/types/Places";
import {MdOutlineQrCodeScanner} from "react-icons/md";
import {Chip} from "@mui/material";
import React from "react";
import {FaMapMarker, FaPrayingHands} from "react-icons/fa";
import {GiKnifeFork, GiNightSleep} from "react-icons/gi";
import {PiGpsFix} from "react-icons/pi";

const usePlaceIcon = (item: Place, segment_id?: string) => {
  if (item.start_place_for) {
    const foundedCurrent = item.start_place_for.find((place) => {
      return String(place.id) === String(segment_id)
    })
    const founded = foundedCurrent ? foundedCurrent : item.start_place_for[0]
    return founded ?
      <Chip icon={founded.has_physical_qr ? <MdOutlineQrCodeScanner/> : <PiGpsFix/>} size={"small"}
            label={founded.has_physical_qr ? "QR CODE" : "GEOTAG"}
            color="secondary"
            variant="outlined"/> : null
  }
};
export default usePlaceIcon;

export const useSinglePlaceIcon = (item?: Place) => {
  if (item?.start_place_for) {
    const founded = item.start_place_for.length > 0 ? item.start_place_for[0] : null
    return founded ?
      <Chip icon={founded.has_physical_qr ? <MdOutlineQrCodeScanner/> : <PiGpsFix/>} size={"small"}
            label={founded.has_physical_qr ? "QR CODE" : "GEOTAG"}
            color="secondary"
            variant="outlined"/> : null
  }
  if (item?.end_place_for) {
    const founded = item.end_place_for.length > 0 ? item.end_place_for[0] : null
    return founded ?
      <Chip icon={founded.has_physical_qr ? <MdOutlineQrCodeScanner/> : <PiGpsFix/>} size={"small"}
            label={founded.has_physical_qr ? "QR CODE" : "GEOTAG"}
            color="secondary"
            variant="outlined"/> : null
  }
};

export const icon = (cat: string) => {
  switch (cat) {
    case 'Pregare':
      return <FaPrayingHands/>
    case 'Mangiare':
      return <GiKnifeFork/>
    case 'Dormire':
      return <GiNightSleep/>
  }

}

export const usePlaceMarker = (item: Place, segment_id?: string) => {
  if (item.start_place_for) {
    const foundedCurrent = item.start_place_for.find((place) => {
      return String(place.id) === String(segment_id)
    })
    const founded = foundedCurrent ? foundedCurrent : item.start_place_for[0]
    return founded ?
      <div style={{position: "relative"}}>
        {founded.has_physical_qr && <MdOutlineQrCodeScanner
            style={{
              position: "absolute",
              zIndex: 10,
              marginLeft: "-10px",
              marginTop: "-30px",
              height: "20px",
              width: "20px"
            }}
            fill={"#fff"}/>}
        {!founded.has_physical_qr && <PiGpsFix
            style={{
              position: "absolute",
              zIndex: 10,
              marginLeft: "-10px",
              marginTop: "-30px",
              height: "20px",
              width: "20px"
            }}
            fill={"#fff"}/>
        }
        <FaMapMarker
          style={{position: "absolute", height: "40px", marginLeft: "-25px", marginTop: "-36px", width: "50px"}}
          fill={"#E91293"}/>
      </div> : null
  }
};
